import { DefaultSeoProps } from 'next-seo';

const SEOConfig: DefaultSeoProps = {
  defaultTitle: 'agentiza.ai - Sistema de IA Conversacional para Empresas',
  titleTemplate: '%s | agentiza.ai',
  description: 'Automatiza el 80% de tu atención al cliente con IA conversacional. WhatsApp Business, Instagram y Web. Responde 24/7 sin contratar más personal.',
  canonical: 'https://agentiza.ai',
  openGraph: {
    type: 'website',
    locale: 'es_MX',
    url: 'https://agentiza.ai/',
    siteName: 'agentiza.ai',
    title: 'agentiza.ai - Sistema de IA Conversacional para Empresas',
    description: 'Automatiza el 80% de tu atención al cliente con IA conversacional. WhatsApp Business, Instagram y Web. Responde 24/7 sin contratar más personal.',
    images: [
      {
        url: 'https://agentiza.ai/og-image.jpg',
        width: 1200,
        height: 630,
        alt: 'agentiza.ai - Inteligencia Artificial Conversacional',
      }
    ],
  },
  twitter: {
    handle: '@aspe_ai',
    site: '@aspe_ai',
    cardType: 'summary_large_image',
  },
  additionalLinkTags: [
    {
      rel: 'icon',
      href: '/favicon.ico',
    },
    {
      rel: 'apple-touch-icon',
      href: '/apple-touch-icon.png',
      sizes: '180x180'
    }
  ],
  additionalMetaTags: [
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1'
    },
    {
      name: 'keywords',
      content: 'ia conversacional, chatbot empresarial, whatsapp business, automatización atención cliente, inteligencia artificial, crm, aspe'
    },
    {
      property: 'dc:creator',
      content: 'agentiza.ai'
    },
    {
      name: 'application-name',
      content: 'agentiza.ai'
    }
  ],
  robotsProps: {
    nosnippet: false,
    notranslate: false,
    noimageindex: false,
    noarchive: false,
    maxSnippet: -1,
    maxImagePreview: 'large',
    maxVideoPreview: -1,
  }
};

export default SEOConfig;